/* eslint-disable @typescript-eslint/no-explicit-any */ import { T } from "@supersig/validate";
import { idValidator } from "../misc/id-validator.mjs";
/** @public */ export const localizationProviderIdValidator = idValidator("localization_provider");
/** @public */ export function createLocalizationProviderValidator(type, props, meta) {
    return T.object({
        id: localizationProviderIdValidator,
        typeName: T.literal("localization_provider"),
        type: T.literal(type),
        props: props ? T.object(props) : T.jsonValue,
        meta: meta ? T.object(meta) : T.jsonValue,
        sourceLanguage: T.object({
            locale: T.string,
            displayName: T.string,
            providerLanguageId: T.string,
            isRTL: T.boolean
        }),
        projectIdentifier: T.string,
        projectDisplayName: T.string,
        organizationId: T.number,
        internalLocalizationProviderId: T.number,
        visibilitySince: T.number
    });
}
